<template>
  <div class="thanks">
    <div class="thanks__intro">
      <Intro
        heading="Tack för att du <br />väljer <span class='uiNoWrap'>e-faktura!</span>"
        description="Det kan ta upp till en vecka innan e-fakturaanmälan är registrerad. Om du hinner få en pappersfaktura av oss den närmaste tiden ska den betalas som vanligt."
      />
    </div>
  </div>
</template>

<script>
import Intro from '@/templates/components/Intro'

export default {
  name: 'Thanks',
  components: {
    Intro
  },
  computed: {
    user: function () {
      return window.user
    }
  },
  mounted: function () {
    window.scrollTo(0, 0)

    if (!this.$store.state.progress.completed) {
      console.log('Thanks, redirect to start due to not completed')
      this.$router.push({ name: 'Start' })
    } else if (!this.user.id) {
      console.log('Thanks, redirect to help due to missing ID')
      this.$router.push({ name: 'Helpdesk' })
    } else {
      console.log('Thanks, reset user')
      this.$store.commit('user/reset')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/templates/views/Thanks/index.vue